import { Prism } from "@components/shared/prism/Prism";
import { useTranslation } from "react-i18next";

import styles from "./Hero.module.scss";

type HeroProps = {
  gradientHero?: boolean;
};

export function Hero({ gradientHero }: HeroProps) {
  const { t } = useTranslation();
  const showPrism = gradientHero !== false;

  return (
    <section id="top" className={styles.heroSection}>
      {showPrism && (
        <div className={styles.heroPrismStage} aria-hidden="true">
          <Prism
            animationType="rotate"
            timeScale={0.25}
            height={3.5}
            baseWidth={5.5}
            scale={3.6}
            hueShift={0}
            colorFrequency={1}
            noise={0.18}
            glow={0.9}
            bloom={1}
            transparent={true}
            suspendWhenOffscreen={true}
          />
        </div>
      )}

      <div aria-hidden="true" className={styles.heroVignette} />

      <div className={`container ${styles.heroContainer}`}>
        <div className={styles.heroInner}>
          <h1 className={styles.heroH1}>{t("hero.title")}</h1>

          <p className={styles.heroLead}>{t("hero.subtitle")}</p>

          <div className={styles.heroCta}>
            <a href="#contact" className="btn btn-light">
              {t("common.cta")}
              <span className="arr">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
